__turbopack_context__.v({
  "link": "WReferenceLinkingToUrlHeaderLink-module__qsJLVq__link",
});
